<template>
  <div class="seomain">
    <div class="info-main">
      <div class="info-top">{{ stinfo.code }}</div>
      <div class="info-status">{{ stinfo.status_info }}</div>
    </div>

    <div class="tab-content">
      <div class="st-list-box pan-105">
        <div class="st-list" v-for="(v, k) in stlist" :key="k" :index="k">
          <div class="st-list-main">
            <p>SKU：{{ v.sku }}</p>
            <p>品类：{{ v.cname }}</p>
            <p>品牌：{{ v.brand }}</p>
            <p>型号：{{ v.model }}</p>
            <p>配置：{{ v.deploy }}</p>
            <p>库存数量：{{ v.inventory_stort }}</p>
            <p>产品总数：{{ v.total }}</p>
            <p>已出库数量：{{ v.outstocknum }}</p>
            <p>备注：{{ v.remark }}</p>
            <van-field
              v-if="stinfo.status < 1"
              v-model="v.position"
              @click="onSearchShow(v.sales_order_products_id, v.warehouse_id, v.products_id)"
              readonly
              type="tel"
              label="备货仓位"
              placeholder="请选择备货仓库"
            />
          </div>
        </div>

        <div v-if="stinfo.status < 1">
          <div class="express_wrap">
            <el-row type="flex">
              <div class="input_wrap" @click="showExPicker = true">
                <input v-model="ex_name" class="input" type="text" disabled placeholder="选择物流公司" />
                <div class="tag">
                  <van-icon class="icon" size="20" color="#999999" name="arrow-down" />
                </div>
              </div>
            </el-row>
            <el-row type="flex">
              <div class="input_wrap">
                <input v-model="ex_code" class="input" type="text" placeholder="输入物流单号" />
                <div id="scan" class="tag" v-if="!ex_code" @click="clickHandle">
                  <van-icon class="icon" size="30" color="#999999" name="photograph" />
                </div>
              </div>
              <div class="btn" @click="submit()">确认出库</div>
            </el-row>
          </div>
          <van-popup v-model="showExPicker" position="bottom" :style="{ height: '50%' }">
            <van-picker
              show-toolbar
              :columns="exlist"
              value-key="name"
              @confirm="onExConfirm"
              @cancel="showExPicker = false"
            />
          </van-popup>
        </div>
      </div>
    </div>

    <!-- 搜索区域 -->
    <van-popup v-model="searchShow" round position="bottom" :style="{ height: '90%', backgroundColor: '#f5f5f5' }">
      <van-search
        v-model="keyword"
        shape="round"
        placeholder="请输入仓位关键字"
        show-action
        @input="inputKeyWordHandle"
        @cancel="searchShow = false"
      />
      <van-cell-group>
        <div v-for="item in feedbackList" :key="item.id">
          <van-cell
            :title="'仓位:' + item.position"
            :value="'库存:' + item.stocknum"
            @click="selectWarehouseHandle(item.id, item.position)"
          />
        </div>
      </van-cell-group>
      <div class="loadingWrap">
        <van-loading v-if="keywordLoading" size="24px" vertical>加载中...</van-loading>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { Dialog } from "vant";
export default {
  components: {},
  props: {},
  data() {
    return {
      ex_code: "", // 物流单号
      ex_name: "", // 物流公司
      exlist: [], // 物流公司数据
      show: !1,
      showExPicker: !1,
      stlist: [],
      stinfo: {},
      paramsid: 0,
      cascaderShow: false,
      fieldValue: "",
      searchShow: false,
      keyword: "",
      loading: false,
      activeId: "",
      productsId: "",
      feedbackList: [],
      keywordLoading: false,
    };
  },
  watch: {},
  computed: {},
  methods: {
    onExConfirm(e) {
      this.ex_name = e;
      this.showExPicker = !1;
    },
    get_st_info: function() {
      let paramsid = this.$route.params.id;
      this.$post(this.$api.stGetXiaoshouoInfo, { id: paramsid }).then((res) => {
        this.stlist = res.data.list.filter((item) => {
          item.position = "";
          item.positionId = "";
          return item;
        });
        this.stinfo = res.data.info;
      });
    },
    get_ex_list: function() {
      this.$post(this.$api.stGetExList, {}).then((res) => {
        this.exlist = res.data;
        // this.exlist = ["自提", "顺丰", "申通"];
      });
    },
    // 点击拍照的回调
    clickHandle() {
      let self = this;
      window.h5sdk.ready(function() {
        window.h5sdk.biz.util.scan({
          type: "barCode",
          onSuccess: (data) => {
            self.ex_code = data.text;
          },
        });
      });
    },
    // 显示仓位搜索的回调
    onSearchShow(id, whId, pId) {
      console.log(arguments);
      this.keyword = "";
      this.feedbackList = [];
      this.activeId = id;
      this.productsId = pId;
      this.warehouseId = whId;
      this.searchShow = true;
    },
    // 根据关键字搜索仓位
    async inputKeyWordHandle(keyword) {
      if (keyword.trim() == "") return (this.feedbackList = []);
      this.keywordLoading = true;
      let result = await this.$post(this.$api.stGetFeedbackList, {
        keyword,
        warehouse_id: this.warehouseId,
        products_id: this.productsId,
      });
      this.keywordLoading = false;
      this.feedbackList = result.data;
    },
    // 选定仓位的回调
    selectWarehouseHandle(id, value) {
      this.stlist = this.stlist.filter((item) => {
        if (item.sales_order_products_id == this.activeId) {
          item.positionId = id;
          item.position = value;
        }
        return item;
      });
      this.searchShow = false;
    },
    /**
     * 验证表单是否填写完整
     * @param {Array} 需要验证的表单数据
     * @return {Boolean} 是否通过验证
     */
    rulesSubmitForm(dataList) {
      return dataList.every((item) => {
        if (item.sales_order_products_id != "" && item.position !== "") {
          return true;
        }
        return false;
      });
    },
    async submit() {
      let flag = this.rulesSubmitForm(this.stlist);
      if (!flag) return this.$toast("请填写物流信息和所有产品对应的仓位信息!");
      let list = [];
      this.stlist.map((item) => {
        let obj = {};
        obj.id = item.sales_order_products_id;
        obj.position_id = item.positionId;
        list.push(obj);
      });
      let params = {
        info: {
          id: this.stinfo.id,
          purchasingtracking: this.ex_name,
          logisticsnumber: this.ex_code,
        },
        list,
      };
      let result = await this.$post(this.$api.stGetXiaoshouoEdit, params);
      this.$toast.success("出库成功");
      this.$router.push("/saleo/list");
    },
  },
  created() {
    this.get_st_info();
    this.get_ex_list();
    window.h5sdk.ready(function() {
      window.h5sdk.biz.navigation.setTitle({ title: "销售出库" });
    });
  },
  mounted() {},
};
</script>
<style lang="scss" scoped>
.info-main {
  padding: 15px;
  color: #fff;
  background: #677588;
  margin-bottom: 15px;
  display: flex;
}
.info-main .info-top {
  flex: 1;
}

.st-out-sec {
  display: flex;
}
.st-ex-code {
  flex: 1;
}
</style>
<style scoped>
.st-out {
  padding: 15px;
  background: #fff;
}
.st-out .st-out-fir {
  margin-bottom: 1.2em;
}
.st-ex-code {
  margin-right: 1.3em;
}
.tab-content .st-opt-btn {
  background: #677588;
  border-radius: 5px;
  padding: 6px;
}
</style>

<style scoped>
.express_wrap {
  background-color: #fff;
  padding: 20px 15px 15px;
}
.express_wrap .el-row {
  margin-bottom: 20px;
}
.express_wrap .el-row .input_wrap {
  flex: 1;
  display: flex;
  position: relative;
  width: 100%;
}
.input_wrap::-webkit-input-placeholder {
  color: #a6a6a6;
}
.input_wrap .tag {
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: absolute;
  top: 0;
  right: 0;
  width: 40px;
  height: 40px;
}
.btn {
  box-sizing: border-box;
  width: 107px;
  height: 41px;
  line-height: 41px;
  text-align: center;
  color: #fff;
  background-color: #677588;
  border-radius: 5px;
  margin-left: 6px;
}
.input {
  flex: 1;
  box-sizing: border-box;
  padding: 0 40px 0 10px;
  line-height: 40px;
  width: 100%;
  height: 40px;
  border: none;
  outline: none;
  border-radius: 5px;
  color: #333;
  background-color: transparent;
  border: 1px solid #a6a6a6;
}
.van-cell.van-field {
  padding: 7px 0;
}
.loadingWrap {
  text-align: center;
}
</style>
